import styled, { css } from 'styled-components';

export const Container = styled.div<{ $reverseEllipsis: boolean }>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ $reverseEllipsis }) =>
    $reverseEllipsis
      ? css`
          text-align: left;
          direction: rtl;
        `
      : null}
`;
